import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { properties } from '../../../../../utils/properties';
import { WrapperPregunta } from '../styles';
import PreguntaEncuestaInput from '../../../atoms/PreguntaEncuestaInput';
import PreguntaEncuestaSmileys from '../../../atoms/PreguntaEncuestaSmileys';

const Pregunta2 = ({
  setBotonDisabled,
  calificacionSmiley,
  setCalificacionSmiley,
  respuestaTexto,
  setRespuestaTexto
}) => {
  const [calificacionMaximaConTexto] = useState(5);
  
  useEffect(() => {
    if (
      calificacionSmiley > calificacionMaximaConTexto ||
      (calificacionSmiley > 0 && calificacionSmiley <= calificacionMaximaConTexto && respuestaTexto !== '')
    ) {
      setBotonDisabled(false);
    } else {
      setBotonDisabled(true);
    }
  }, [calificacionSmiley, respuestaTexto]);

  return (
    <WrapperPregunta>
      <div className="contenido contenido-padding-fix">
        <div className="subtitulo">2 de 2 preguntas</div>
        <div className="pregunta">{properties.encuestaSatisfaccion.pregunta2Titulo}</div>
        <div>
          <PreguntaEncuestaSmileys setCalificacionSmiley={setCalificacionSmiley} />
        </div>
        {calificacionSmiley > 0 && (
          <PreguntaEncuestaInput 
            campoObligatorio={calificacionSmiley <= calificacionMaximaConTexto}
            respuestaTexto={respuestaTexto}
            setRespuestaTexto={setRespuestaTexto}
            maxLength={200}
            labelPrimario={properties.encuestaSatisfaccion.pregunta2Label1}
            labelSecundario={properties.encuestaSatisfaccion.pregunta2Label2}
            label={calificacionSmiley < 6 ? 1 : 2}
          />
        )}
      </div>
    </WrapperPregunta>
  );
};

Pregunta2.propTypes = {
  setBotonDisabled: PropTypes.func.isRequired,
  calificacionSmiley: PropTypes.number.isRequired,
  setCalificacionSmiley: PropTypes.func.isRequired,
  respuestaTexto: PropTypes.string.isRequired,
  setRespuestaTexto: PropTypes.func.isRequired,
};

export default Pregunta2;
